import { Inject, Injectable } from '@angular/core';
import { CrudService } from 'src/app/core/services/crud.service';
import { PRIORITY_BUILDING_ENDPOINT, PRIORITY_BUILDING_QUERY_SERVICE_INSTANCE } from '../filiere.config';
import { QueryService } from 'src/app/core/services/query.service';
import { ApiService } from 'src/app/core/services/api.service';
import { SnackbarService } from 'src/app/core/services/snackbar-psa.service';
import { IPageEvent } from 'src/app/core/models/paginator.model';

@Injectable({
  providedIn: 'root'
})
export class BuildingsService extends CrudService<any>{

  constructor(
      @Inject(PRIORITY_BUILDING_QUERY_SERVICE_INSTANCE) public readonly query: QueryService<any>,
      public readonly apiService: ApiService,
      protected  override readonly snackbar : SnackbarService
    ) {
      super(PRIORITY_BUILDING_ENDPOINT, apiService, snackbar);
    }

    getAllFiltered(parameter : IPageEvent, searchData?:any, filters?: Record<string, any>){
            const stringSearch = searchData || ''
            let queryParams: string[] = [];
            
            if(filters){
              Object.keys(filters).forEach(key => {
        
                if (filters[key]) {
                  if(key.includes('_from')){
                    const fv = `${key.split('_from')[0]}||gte||${filters[key]}`;
                    queryParams.push(`filter=${encodeURIComponent(fv)}`);
                  }else if(key.includes('_to')){
                    const fv = `${key.split('_to')[0]}||lte||${filters[key]}`;
                    queryParams.push(`filter=${encodeURIComponent(fv)}`);
                  }
                  else{
                    if(filters[key] instanceof Object){
                      Object.keys(filters[key]).forEach(k => {
                        if (filters[key][k]){
                        const fv = `${key}.${k}||eq||${filters[key][k]}`;
                        queryParams.push(`filter=${encodeURIComponent(fv)}`);
                        }
                      })
                    }else{
                      const fv = `${key}||eq||${filters[key]}`;
                      queryParams.push(`filter=${encodeURIComponent(fv)}`);
                    }
                  }
                }
              });
            }
            console.log(queryParams);
            queryParams.push(`page=${parameter.pageIndex}`);
            queryParams.push(`limit=${parameter.pageSize}`);
            if(searchData) queryParams.push(`search=${stringSearch}`);
            const queryString = queryParams.length > 0 ? `?${queryParams.join('&')}` : '';
            
            return this.apiService.get(PRIORITY_BUILDING_ENDPOINT + queryString); 
          }


    massiveDelete(ids: number[]) : any{ 
      return this.apiService.delete(PRIORITY_BUILDING_ENDPOINT, 0, false, {ids: ids} );
    }

}
